import React from "react";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Refresh, ViewCarousel, Visibility } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import Detail from "./Modals/Detail";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import axios from "axios";
import { toast } from "react-toastify";
import Button from "../../components/CustomButtons/Button";
import PropTypes from "prop-types";
import { format } from "date-fns";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detailModel: false,
      selectedId: null,
    };
  }

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDetailAction = (row) => {
    this.setState({
      selectedId: row[0],
      detailModel: true,
    });
  };

  handleGetServiceLogs = () => {
    const data = {
      sales_area_ids: this.props.vestiging_id,
    };
    axios.post("core/servicesLog/getlogs", data).then((response) => {
      toast.success("Getting log request started");
    });
  };

  handleCustomDatum = (item) => {
    return format(new Date(item.created_at), "dd-MM-yyyy HH:mm:ss");
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Service logs"} tKey={"servicelogs.pagetitle"} />} />

        <GridContainer>
          <VestigingenFilter />
          <GridItem>
            {this.props.vestiging_id ? (
              <Button className={classes.marginRight} color={"danger"} onClick={() => this.handleGetServiceLogs()}>
                <Refresh className={classes.icons} />
                <TranslationWrapper tDefault={"Get servicelogs"} tKey={"servicelogs.submit"} />
              </Button>
            ) : null}
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Visibility,
                  tooltip: (
                    <TranslationWrapper tDefault={"Show details"} tKey={"servicelogs.table.tooltip.showDetails"} />
                  ),
                  action: this.handleDetailAction,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "vestiging.systeemNaam", editable: false },
                { customData: this.handleCustomDatum },
                { dbfield: "event", editable: false },
              ]}
              dbfields={"id,created_at,vestiging_id,vestiging.id,vestiging.systeemNaam,event,log"}
              fetchUrl={"core/servicesLog"}
              filters={this.props.filters}
              headerIcon={<ViewCarousel />}
              headers={[
                {
                  label: getTranslation("servicelogs.table.id", "#"),
                  sortable: false,
                },
                {
                  label: getTranslation("servicelogs.table.vestiging", "Vestiging"),
                  sortable: false,
                },
                {
                  label: getTranslation("servicelogs.table.datum", "Datum"),
                  sortable: false,
                },
                {
                  label: getTranslation("servicelogs.table.tafel", "Event"),
                  width: "15%",
                  sortable: false,
                },
              ]}
              reduxKey={"apilog"}
              showAutoRenew
              showRefresh
              tableTitle={<TranslationWrapper tDefault={"Service logs"} tKey={"servicelogs.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        {/*POPUPS*/}
        <Detail
          open={this.state.detailModel}
          servicelogId={this.state.selectedId}
          toggle={() => this.toggleModal("detailModel")}
        />
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
